import * as React from 'react';

interface Props
  extends React.DetailedHTMLProps<
      React.HtmlHTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    > {
  children: React.ReactNode;

   // Adding a property to add external css class. 
   divClassName?: string;
}

const Row = (props: Props) => {
  // Check if external css properties comes from parent
  let divUserClass = props.divClassName === null ? '' : props.divClassName;
  return (
    <div {...props} className={`row ${props.className || ''} ${divUserClass}`}>
      {props.children}
    </div>
  );
};

export default Row;



// WEBPACK FOOTER //
// ./src/Components/Row.tsx